import React from 'react';
import { Modal, Text } from '@zillow/constellation-10';

export interface ErrorModalProps {
  error: string;
  onClose: () => void;
}

export const ErrorModal = ({ error, onClose }: ErrorModalProps) => {
  return (
    <Modal
      open={true}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      size={{ base: 'fullScreen', lg: 'md' }}
      header="Error"
      body={<Text css={{ padding: '600' }}>{error}</Text>}
    />
  );
};
